import { render, staticRenderFns } from "./ContactAddressSearch.vue?vue&type=template&id=a8845210"
import script from "./ContactAddressSearch.vue?vue&type=script&lang=ts"
export * from "./ContactAddressSearch.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a8845210')) {
      api.createRecord('a8845210', component.options)
    } else {
      api.reload('a8845210', component.options)
    }
    module.hot.accept("./ContactAddressSearch.vue?vue&type=template&id=a8845210", function () {
      api.rerender('a8845210', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/contacts/ContactAddressSearch.vue"
export default component.exports